
import React, {useState} from "react";
import {FaChevronDown, FaChevronRight, FaEraser, FaSearch} from "react-icons/fa";
import InputCheckbox from "../../input/input-checkbox.jsx";
import {FaLocationDot} from "react-icons/fa6";
import {getAssetPath} from "../../../utils/get-asset-path.js";
import InputForm from "../../input/input-form.jsx";
import Button from "../../button/button.jsx";

const exitPng = getAssetPath("img/sentry_lane/EXIT.png");
const entrancePng = getAssetPath("img/sentry_lane/ENTRANCE.png");
const cameraSvg = getAssetPath("img/sentry_lane/sentry.lane.svg");

const TreeLanes = ({checked, setChecked, showFilter, nodesToShow, clearFilter, search, onChange, state}) => {
    const [expanded, setExpanded] = useState({});

    function toggleExpand(key) {
        setExpanded(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    }

    function toggleCheck(el){
        const newState = {...checked};
        newState[el.key] = {...newState[el.key], checked: !newState[el.key].checked}

        if(newState[el.key].children.length > 0){
            newState[el.key].children.forEach(child => updateChildren(newState, child, newState[el.key].checked))
        }

        if(newState[el.key].parentKey){
            correctParentStatus(newState, newState[el.key].parentKey)
        }

        setChecked(newState);
    }

    function updateChildren(state, key, value){
        const node = state[key];
        if (!node) return;

        state[key] = {
            ...node,
            checked: value,
        };

        node.children.forEach(childKey =>
            updateChildren(state, childKey, value)
        );
    }

    function correctParentStatus(state, parentKey){
        const childrenKey = state[parentKey].children;

        const childrenObj = childrenKey.map(k => state[k]).filter(Boolean);

        const hasChecked = Object.values(childrenObj)
            .some(node => node.checked);

        if(hasChecked){
            state[parentKey] = {...state[parentKey], checked: true}
        } else {
            state[parentKey] = {...state[parentKey], checked: false}
        }

        if(state[parentKey].parentKey){
            correctParentStatus(state, state[parentKey].parentKey);
        }
    }

    function getLaneDirection(direction) {
        if(direction === "EXIT") return <img style={{height: 16}} src={exitPng}/>
        return <img style={{height: 16}} src={entrancePng}/>
    }

    function toggleCheckAll(value) {
        const newState = { ...checked };

        Object.keys(newState).forEach(key => {
            newState[key] = {
                ...newState[key],
                checked: value
            };
        });

        setChecked(newState);
    }

    return(
       <>
        {
            showFilter &&
                <div className="flex gap-4">
                    <InputForm id="filter" label="Pesquisa" value={state} onChange={onChange} classNameWrapper={"w-full"} />

                    <div className="flex gap-2">
                        <Button target="text-white" id="btn-clear" title="Limpar" onClick={() => clearFilter()}>
                            <FaEraser />
                        </Button>

                        <Button target="primary" id="btn-search" title="Buscar" onClick={() => search()}>
                            <FaSearch />
                        </Button>
                    </div>
                </div>
        }
           <InputCheckbox
               label="Todos"
               checked={Object.values(checked).every(n => n.checked)}
               onChange={(e) => toggleCheckAll(e.target.checked)}
           />
           <ul className="border border-[#dddddd] mt-2 max-h-[70vh] overflow-auto">
               {nodesToShow.map(el =>
                   <li key={el.key} className="w-full p-1 odd:bg-[#f2f2f2] even:bg-[#ffffff] border-b border-[#dddddd] last:border-b-0 flex flex-col  justify-center gap-0.5">
                       <div className="flex gap-0.5">
                           {expanded[el.key] ? (
                               <FaChevronDown size={16} onClick={() => toggleExpand(el.key)} />
                           ) : (
                               <FaChevronRight size={16} onClick={() => toggleExpand(el.key)} />
                           )}
                           <InputCheckbox
                               checked={checked[el.key]?.checked || false}
                               onChange={() => toggleCheck(el)}
                           />
                           <FaLocationDot size={16}/>
                           {el.label}
                       </div>
                       {expanded[el.key] &&
                           <ul className="ms-4">
                               {el.children.map(el =>
                                   <li key={el.key} className="p-1 flex-col">
                                       <div className="flex gap-0.5">
                                           {expanded[el.key] ? (
                                               <FaChevronDown size={16} onClick={() => toggleExpand(el.key)} />
                                           ) : (
                                               <FaChevronRight size={16} onClick={() => toggleExpand(el.key)} />
                                           )}
                                           <InputCheckbox
                                               checked={checked[el.key]?.checked || false}
                                               onChange={() => toggleCheck(el)}
                                           />
                                           {getLaneDirection(el.data.regionType)}
                                           {el.label}
                                       </div>
                                       {expanded[el.key] &&
                                           <ul className="ms-12">
                                               {el.children.map(el =>
                                                   <li key={el.key} className="p-1 flex gap-0.5">
                                                       <InputCheckbox
                                                           checked={checked[el.key]?.checked || false}
                                                           onChange={() => toggleCheck(el)}
                                                       />
                                                       <img className="mr-1" src={cameraSvg}/>
                                                       {el.label}
                                                   </li>
                                               )}
                                           </ul>
                                       }
                                   </li>
                               )}
                           </ul>
                       }
                   </li>
               )}
           </ul>
       </>
    )
}

export default TreeLanes;